import * as React from 'react';
import cn from 'clsx';
import { Image } from '@cian/ui-kit';

import { File, FileTypes } from '../../../File';
import { Typography } from '../../../Typography';
import Refresh from './assets/refresg.svg';
import Cross from './assets/cross.svg';
import * as styles from './styles.css';
import { ProgressBar } from '../../../ProgressBar';

export interface IFileContentProps {
  file: File | null;
  hasError: boolean;
  handleClickCross: (e: React.MouseEvent) => void;
  handleReload: (e: React.MouseEvent) => void;
  isFileUploading?: boolean;
}

const getFileSize = (bytes: number) => {
  if (bytes.toString().length <= 6) {
    return `${Math.round(bytes / 1000)} кб`;
  } else {
    return `${Math.round(bytes / 1000 / 1000)} мб`;
  }
};

export const FileContent: React.FC<IFileContentProps> = ({
  file,
  hasError,
  isFileUploading,
  handleClickCross,
  handleReload,
}) => {
  if (!file) {
    return null;
  }

  const fileName = file.name;
  const fileSize = getFileSize(file.size);
  const fileExtension = file.name.split('.').pop() as FileTypes;

  return (
    <div className={styles.file}>
      <div className={styles['file-icon']}>{fileExtension && <File fileType={fileExtension} />}</div>

      <div className={styles.content}>
        <div className={cn(styles['file-name'], hasError && styles.error)}>
          <Typography.Text level={4}>{fileName}</Typography.Text>
        </div>

        {fileSize && !isFileUploading && (
          <div className={styles['file-size']}>
            <Typography.Text level={6}>{fileSize}</Typography.Text>
          </div>
        )}

        {isFileUploading && (
          <div className={styles['progress-bar']}>
            <ProgressBar />
          </div>
        )}
      </div>

      <button className={styles['icon-button']} onClick={hasError ? handleReload : handleClickCross}>
        <Image src={hasError ? Refresh : Cross} width={24} height={24} />
      </button>
    </div>
  );
};

FileContent.displayName = 'FileContent';
